import type { ReactNode } from 'react';

export function Field({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  return (
    <label className="block">
      <span className="text-[12px] font-semibold text-ink2">{label}</span>
      {hint && <span className="mt-0.5 block text-[11px] text-ink3">{hint}</span>}
      <div className="mt-1.5">{children}</div>
    </label>
  );
}
